module.exports = __webpack_public_path__ + "img/Virgo.94146df0.svg";